// App.jsx


import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Footer from './components/footer/Footer';
import AppRoutes from './routes/Routes';
import { AuthProvider } from './hooks/useAuth';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import './App.css';

// ✅ Load Stripe instance
// const stripePromise = loadStripe("pk_live_51QPNfuJtJ9tH3nNHf0AnKFAkILeb9KwMaEz9y3LIGEX7w76cGtiy9jwCEtEQRNs1b4KJyddgHEeSUMBKUZlf8qEm00Pd9xmFxc");

// grab stripe key from .env - only load if key exists
const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

function App() {
  return (
    <AuthProvider>
      <Elements stripe={stripePromise}>
        <Router>
          <MainApp />
        </Router>
      </Elements>
    </AuthProvider>
  );
}

const MainApp = () => {
  const location = useLocation();

  // ✅ Define dashboard routes where footer should NOT appear
  const dashboardRoutes = [
    '/agent-dashboard',
    '/user-dashboard',
    '/upload-property',
    '/agent-listings',
    '/edit-listing',
    '/admin-manager',
    '/calendar',
    '/edit-profile',
    '/seam-success',
    '/tenant-dashboard',
    '/tenant-login',
  ];

  // ✅ Check if current route includes any dashboard path
  const hideFooter = dashboardRoutes.some(route => location.pathname.startsWith(route));

  return (
    <div className="App">
      <main className="content">
        <AppRoutes />
      </main>
      {!hideFooter && <Footer />} {/* ✅ Conditionally render footer */}
    </div>
  );
};

export default App;
